import { clearTrackingEvents, setTrackingEvents } from '../../services/trackingService';
import './music.component.scss';

export default function MusicView() {
    return {
        oncreate: () => setTrackingEvents('a.target-link', 'music'),
        onremove: () => clearTrackingEvents('a.target-link'),
        view: () => (<>
            <div class="headline">
                <h2>Listen to Void Hunter</h2>
                <h3>"Anthropocene" EP available now!</h3>
            </div>
            <div class="content music-content">
                <div class="content__col box-border-rough bandcamp-lg">
                    <div>
                    <iframe
                        style="border: 0; width: 350px; height: 621px;"
                        src="https://bandcamp.com/EmbeddedPlayer/album=4054286118/size=large/bgcol=333333/linkcol=0f91ff/transparent=true/"
                        seamless
                    >
                        <a class="target-link" data-type="streaming" data-target="bandcamp" href="https://voidhunter.bandcamp.com/album/anthropocene">Anthropocene by Void Hunter</a>
                    </iframe>
                    </div>
                </div>
                <div class="content__col box-border-rough streaming">
                    <div class="content__row box-border-plain bandcamp-med">
                        <iframe
                            style="border: 0; width: 100%; height: 120px;"
                            src="https://bandcamp.com/EmbeddedPlayer/album=4054286118/size=large/bgcol=333333/linkcol=0f91ff/tracklist=false/artwork=small/transparent=true/"
                            seamless
                        >
                            <a class="target-link" data-type="streaming" data-target="bandcamp" href="https://voidhunter.bandcamp.com/album/anthropocene">Anthropocene by Void Hunter</a>
                        </iframe>
                    </div>
                    <div class="content__row box-border-plain bandcamp-sm">
                        <iframe
                            style="border: 0; width: 100%; height: 42px;"
                            src="https://bandcamp.com/EmbeddedPlayer/album=4054286118/size=small/bgcol=333333/linkcol=e32c14/transparent=true/campaign=vh-home/"
                            seamless
                        >
                            <a class="target-link" data-type="streaming" data-target="bandcamp" href="https://voidhunter.bandcamp.com/album/anthropocene">Anthropocene by Void Hunter</a>
                        </iframe>
                    </div>
                    <div class="content__row box-border-plain tidal">
                        <a class="target-link" data-type="streaming" data-target="tidal" href="https://tidal.com/browse/album/316985456" target="_blank">
                            <img src="assets/tidal-icon-white-rgb.png" alt="Tidal" />
                            <span>Tidal</span>
                        </a>
                    </div>
                        <div class="content__row box-border-plain apple">
                        <a class="target-link" data-type="streaming" data-target="apple-music" href="https://music.apple.com/us/album/anthropocene-ep/1707959691" target="_blank">
                            <img src="assets/apple-music-mono-black.png" alt="Listen on Apple Music" />
                            <span>Apple Music</span>
                        </a>
                    </div>
                        <div class="content__row box-border-plain youtube">
                        <a class="target-link" data-type="streaming" data-target="youtube" href="https://music.youtube.com/playlist?list=OLAK5uy_lol2T2wucWEDL_wdKrc7dfn5_LeCIIPUo&si=SFuXyiUpsZjje1Pz" target="_blank">
                            <img src="assets/yt_logo_mono_light.png" alt="YouTube" />
                            <span>YouTube</span>
                        </a>
                    </div>
                        <div class="content__row box-border-plain amazon">
                        <a class="target-link" data-type="streaming" data-target="amazon" href="https://music.amazon.com/albums/B0CJB2P8HY" target="_blank">
                            <img src="assets/amazon-music-stacked-black.png" alt="Amazon Music" />
                            <span>Amazon Music</span>
                        </a>
                    </div>
                        <div class="content__row box-border-plain pandora">
                        <a class="target-link" data-type="streaming" data-target="pandora" href="https://pandora.app.link/3Ls0kveetDb" target="_blank">
                            <img src="assets/Pandora_App_Icon_Black.png" alt="Pandora" />
                            <span>Pandora</span>
                        </a>
                    </div>
                    <div class="content__row box-border-plain spotify">
                        <a class="target-link" data-type="streaming" data-target="spotify" href="https://open.spotify.com/album/2YO5FS5YCJHvc4ECzU4TDC?si=-qjz1OioS4m4nlDKwf9Bkg" target="_blank">
                            <img src="assets/Spotify_Logo_RGB_Black.png" alt="Spotify" />
                            <span>Spotify</span>
                        </a>
                    </div>
                </div>
            </div>
        </>),
    };
}
